import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import ViewListIcon from '@material-ui/icons/ViewList';

import Typography from '@material-ui/core/Typography';

import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import AddEdit from './AddEdit';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import AddIcon from '@material-ui/icons/Add';
import { TablePagination, TextField } from '@mui/material';

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import MethodAddEdit from './MethodAddEdit';
import OptionAddEdit from './OptionAddEdit';
import { navigate } from '@storybook/addon-links/dist/preview';

import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  container: {
    maxHeight: 'calc(100vh - 330px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '600px',
  },
  alignCenter: {
    textAlign: 'center',
  },
  // contentPadding:{
  //   '&.MuiDialogContent-root':{
  //     padding:'8px 62px'
  //   }
  // }
  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
}));

const TransactionMethod = () => {
  const classes = useStyles();
  const history = useHistory();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [list, setList] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [addDialog, setAddDialog] = useState(false);
  const [addDialogOption, setAddDialogOption] = useState(false);

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [count, setCount] = useState(0);

  const [methodId, setMethodId] = useState('');

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setAddDialog(false);
  };

  const openAddDialogOption = () => {
    setAddDialogOption(true);
  };
  const closeAddDialogOption = () => {
    console.log('closeAddDialog');
    setAddDialogOption(false);
  };
  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const getList = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let url = `/api/v1/private/transaction/transaction-methods`;

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        setList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
    setLoading(false);
  };
  const getById = async id => {
    openAddDialog();
  };
  const getOptionByMethodId = async () => {
    openAddDialogOption();
  };
  const handleDelete = async () => {
    setLoadingDelete(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/transaction/transaction-method/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('response', response);
        let newList = list.filter(res => res.id !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
        handleSnakbarOpen(response.data.message, 'success');
      })
      .catch(function(error) {
        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setDeleteDialog(false);
      });
    setLoadingDelete(false);
  };

  const getCountry = async () => {
    await axios
      .get(`/api/v1/public/countries`)
      .then(function(response) {
        setAllCountry(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 20; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };

  useEffect(() => {
    getCountry();
  }, []);

  useEffect(
    () => {
      getList();
    },
    [page],
    refresh,
  );

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle} spacing={3}>
        <Grid item md={8}>
          <Typography variant="h2">All Transaction Method</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper} className={classes.container}>
              <Table stickyHeader aria-label="simple table">
                <TableHead className={classes.tableHeadStyle}>
                  <TableRow>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Options</TableCell>
                    <TableCell align="left">Created At</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left" className={classes.cellWidth}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableBodyStyle}>
                  {list.length > 0 && !loading
                    ? list.map((row, i) => (
                        <TableRow hover key={i}>
                          <TableCell align="left" scope="row">
                            {row.name}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.options && row.options.map((item, index) => <div key={index}>{item.name}</div>)}
                          </TableCell>

                          <TableCell align="left" scope="row">
                            {moment(row.createdAt).format('D MMM YYYY')}
                          </TableCell>

                          <TableCell align="left">
                            <img src={row.active ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                          </TableCell>
                          <TableCell align="left">
                            {/* <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                              <VisibilityIcon />
                            </IconButton> */}
                            <IconButton
                              // color="primary"
                              title="View All Option"
                              className={classes.editButton}
                              onClick={() => {
                                history.push({
                                  pathname: `/method-option`,
                                  state: {
                                    id: row.id,
                                    method_name: row.name,
                                  },
                                });
                              }}>
                              <ViewListIcon />
                            </IconButton>
                            <IconButton
                              className={classes.editButton}
                              onClick={() => {
                                setEditIndexNo(i);
                                getById();
                                // openAddDialog();
                                setEditObj(row);
                              }}>
                              <EditIcon />
                            </IconButton>
                            {/* <Link
                              to={{
                                pathname: '/method-option',

                                state: { id: row.id },
                              }}>
                              options
                            </Link> */}

                            <IconButton
                              color="secondary"
                              onClick={() => {
                                handleDeleteDialogClickOpen();
                                setDeleteId(row.id);
                              }}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                  {!loading && list.length < 1 ? (
                    <TableRow>
                      <TableCell colSpan="10" style={{ textAlign: 'center' }}>
                        {message}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {loading && pageLoading()}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
              component="div"
              rowsPerPageOptions={[]}
              count={count}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={perPage}
            /> */}
          </Paper>
        </Grid>
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <TableContainer style={{ marginBottom: '40px' }}>
                <div className={classes.titleDiv}>
                  <div className={classes.iconDiv}>
                    <IconButton
                      style={{ background: 'gainsboro' }}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={handleCloseDetailView}>
                      <Clear fontSize="inherit" />
                    </IconButton>
                  </div>

                  <Typography variant="h1" className={` ${classes.alignCenter}`}>
                    Details
                  </Typography>
                </div>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell scope="row" />
                      <TableCell align="right" />
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Company Name</TableCell>
                      <TableCell align="right">{detailViewItem.name}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">First Name</TableCell>
                      <TableCell align="right">{detailViewItem.firstName}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Last Name</TableCell>
                      <TableCell align="right">{detailViewItem.lastName}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Business Street</TableCell>
                      <TableCell align="right">{detailViewItem.businessStreet}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Business Country</TableCell>
                      <TableCell align="right">{detailViewItem.businessCountry}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Postal Zip</TableCell>
                      <TableCell align="right">{detailViewItem.postalZip}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Mobile Number</TableCell>
                      <TableCell align="right">{detailViewItem.mobileNumber}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Business Email</TableCell>
                      <TableCell align="right">{detailViewItem.email}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Type Of Business</TableCell>
                      <TableCell align="right">{detailViewItem.typeOfBusiness}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Agent Find Us From</TableCell>
                      <TableCell align="right">{detailViewItem.agentFindUsFrom}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Address</TableCell>
                      <TableCell align="right">{detailViewItem.address}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Open Time</TableCell>
                      <TableCell align="right">{detailViewItem.openTime}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Close Time</TableCell>
                      <TableCell align="right">{detailViewItem.closeTime}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Status</TableCell>
                      <TableCell align="right">
                        {detailViewItem.status ? (
                          <Typography variant="h6" style={{ color: 'green' }}>
                            Available
                          </Typography>
                        ) : (
                          <Typography variant="h6" style={{ color: 'red' }}>
                            Not Available
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <MethodAddEdit
              list={list}
              allCountry={allCountry}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            />
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Option Dialog start============================== */}

      <div>
        <Dialog
          open={addDialogOption}
          onClose={closeAddDialogOption}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <OptionAddEdit
              list={list}
              allCountry={allCountry}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialogOption}
              addDialog={addDialogOption}
              methodId={methodId}
            />
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogTitle>
              <Typography variant="h3">Are you sure to delete ?</Typography>
            </DialogTitle>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <LoadingButton loading={loadingDelete} color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default TransactionMethod;
